export default "__VITE_ASSET__D48na8dm__"